/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { ZoneInstance } from "../models/zone-instance";
import { ZoneService } from "../services/zone.service";
import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { PAGING_ITEMS_PER_PAGE } from "../app-constants";
import { PagedResults } from "app/models/paged-results";

@Injectable()
export class ZoneInstancesPagingResolver implements Resolve<PagedResults<ZoneInstance>> {

  constructor(
    private zoneService: ZoneService
  ) { }

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<PagedResults<ZoneInstance>> {

    let numberOfZones: number = route.data['zonesPerPage'];
    if (numberOfZones == null || numberOfZones < 1) {
      numberOfZones = PAGING_ITEMS_PER_PAGE;
    }
    
    try {
      return await this.zoneService.getAllZoneInstancesForPaging(0, numberOfZones, "ASC", "");
    } catch (error) {
      console.error("Problem resolving Zones!", error);
    }
  }

}
